import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { cookie } from '@ifeng-fe/ui_base';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Player } from 'ThreeTerminal_pc_dynamic';

let autoPlay = true;

if (typeof document !== 'undefined' && cookie.get('autoplay') === 'no') {
    autoPlay = false;
}

let playermsg = {
    width: 480,
    height: 380,
    isAuth: 'auth',
    autoPlay,
};

class Video extends React.PureComponent {
    static propTypes = {
        topic: PropTypes.string,
        videoinfo: PropTypes.object,
    };

    state = {
        checked: autoPlay,
    };

    handleChange = () => {
        const { checked } = this.state;

        if (!checked) {
            cookie.set('autoplay', 'yes');
        } else {
            cookie.set('autoplay', 'no');
        }

        this.setState({
            checked: !checked,
        });
    };

    render() {
        const { checked } = this.state;
        let { topic, videoinfo } = this.props;

        if (topic !== '') {
            playermsg = { ...playermsg, subject: topic };
        }
        videoinfo.keywords = '新时代'

        return (
            <div className={styles.video_box}>
                <div className={styles.video}>
                    <Player videoConfig={videoinfo} playermsg={playermsg} />
                </div>
                <input type="checkbox" checked={checked ? 'checked' : ''} onChange={this.handleChange} />
                <span>自动播放</span>
            </div>
        );
    }
}

export default errorBoundary(Video);
